import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CityTaxSummaryStatisticsStoreEffects } from './effects';
import { cityTaxSummaryStatisticsReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      'cityTaxSummaryStatistics',
      cityTaxSummaryStatisticsReducer,
    ),
    EffectsModule.forFeature([CityTaxSummaryStatisticsStoreEffects]),
  ],
})
export class CityTaxSummaryStatisticsStoreModule {}
